// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2kTdI","title":"Header_title__19Mx0","left":"Header_left__967Ep","clinicName":"Header_clinicName__3Km78"};